<template>
<div class="grid">
<div class="col">
	<div class="rage_wrap_outer ml-2 mt-1">
		<div class="rage_wrap_inner animate_class" :style="rangeClass"></div>
	</div>
</div>

<div class="col-fixed"  style="width:150px">
	<div class="flex align-items-center justify-content-end ">
<p class="m-0 font-bold text-sm pr-4 text-primary">{{visible_days_left}} {{dayslefttext}}</p>
</div>
</div>


</div>
	
</template>

<script>
export default {

  name: 'DateRangedisplay',
  props:["daydifferencedata"],
  data () {
    return {
    	rangeClass:null
    }
  },
  mounted()
  {

  	this.calculateRange()
  },
  computed:{  	
  	dayslefttext()
  	{
  		if(this.daydifferencedata)
  		{
  			if(this.daydifferencedata.daysleft>0)
  			{
  				return this.$store.state.languages.lang_phrases.gun_kaldi
  				
  			}
  			else
  			{
  				return this.$store.state.languages.lang_phrases.sona_erdi
  			}
  		}
  		else
  		{
  			return ""
  		}
  			
  	},
  	visible_days_left()
  	{
  		
  		if(this.daydifferencedata && this.daydifferencedata.daysleft)
  		{
  			if(this.daydifferencedata.daysleft>0)
  			{
  				return this.daydifferencedata.daysleft
  				
  			}
  			else
  			{
  				return ""
  			}
  			
  		}
  		else
  		{
  			return ""
  		}
  	}
  },
  methods:{
  	calculateRange()
  	{
  		
  		setTimeout(()=>{
  			if(this.daydifferencedata.daydifference<30)
	  		{
	  			this.rangeClass =   "width:"+this.daydifferencedata.daydifference+"%;background-color:#352f8d"
	  		}

	  		if(this.daydifferencedata.daydifference>30 && this.daydifferencedata.daydifference<70)
	  		{
	  			this.rangeClass =  "width:"+this.daydifferencedata.daydifference+"%;background-color:#3b82f6"
	  		}

	  		if(this.daydifferencedata.daydifference>70 && this.daydifferencedata.daydifference<100)
	  		{
	  			this.rangeClass =  "width:"+this.daydifferencedata.daydifference+"%;background-color:#a82400"
	  		}

	  		if(this.daydifferencedata.daydifference==100)
	  		{
	  			this.rangeClass =  "width:"+this.daydifferencedata.daydifference+"%;background-color:#a82400"
	  		}
  		},10)

  	}
  }
}
</script>

<style lang="css" scoped>
	.rage_wrap_outer{
		width: 100%;
		border: 3px solid rgba(53,47,141,1);
		border-radius: 6px;
		height: 14px;
		position: relative;
		padding: 1px;
	}
	.rage_wrap_inner{
		height: 8px;
		width: 0%;
		position: absolute;
		border-radius: 4px;
		left: 0.5px;
	}
	.animate_class{
		-webkit-transition: all 600ms ease-out;
		-moz-transition: all 600ms ease-out;
		-ms-transition: all 600ms ease-out;
		-o-transition: all 600ms ease-out;
		transition: all 600ms ease-out;
	}
</style>